import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Abouttext extends Component {
    render() {
        return (
            <section className="corona-count-sec section-padding bg-custom-white">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="corona-count-bottom bg-custom-white">
                                <div className="row align-items-center">
                                    <div className="col-lg-12">
                                        <div className="content-sec mb-md-80">
                                            <h3 className="text-custom-black fw-600">About History Quality</h3>
                                            <p className="fs-16 text-theme fw-600">Clinical cannabis or cliAbout History Qualitynical weed is cannabis and cannabinoids</p>
                                            <p className="text-light-white">Impacts of ceaseless use may incorporate bronchitis, a cannabis reliance condition, and unpretentious weaknesses of consideration and memory. These shortages continue while constantly inebriated. Thought about.</p>
                                            <ul className="custom">
                                                <li>Impacts of constant use may incorporate bronchitis, a cannabis reliance disorder, and unobtrusive impedances.</li>
                                                <li>Effects of consistent use may join bronchitis, a cannabis dependence issue, and unpretentious impedances.</li>
                                                <li>A cannabis reliance issue, and honest impedances.</li>
                                            </ul>
                                            <Link to="/about" className="btn-submit btn_text_effect"><span className="button_title">Learn More</span></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Abouttext;